import * as Config from '../../../config';
import React from 'react';
import { useSelector } from "react-redux";
import PropTypes from 'prop-types';

import DividingLine from '../left-bar/DividingLine';
import Avatar from './Avatar';

// REUNITE THE COLORS ON THE DEFAULT CONFIG ?
const COLORS = ['#00A6ED', '#EC7D10', '#EF476F', '#9654FA', '#00A6ED',/* '#5CA7FB', '#D2BF43', '#5C5CFB' */];

function BlockSession({ room }) {
  const socket = useSelector( state => state.socketPM);
  const joinSession = (roomID, token) => () => {
    localStorage.setItem('a5RAW%93W!gph8', roomID); // Room ID
    localStorage.setItem('5gxYD7Y&PqWmDW', true); // Active
    localStorage.setItem('UFg%PZHqK&5j4C', token); // Token
    socket.emit("join room", { roomID, admin: false, active: true, token });
  }
  const host = room.a[0];
  const duration = room.duration ? Config.msToTime(room.duration) : 'undefined';
  return (
    <>
      <div key={room.id} className={'flexRow space-between'}>
        <div className={'flexColumn'} style={{gap: 8, maxWidth: 130}}>
          <span className={'type-medium fz13 type-light ellipsis'}>{room.name ? room.name : 'No Name'}</span>
          <span className={'type-medium fz13 type-secondary ellipsis'}>{room.genre ? room.genre : 'No genre'}</span>
          { host && (
            <div className={'flexRow'} style={{gap: 8}}>
              <Avatar key={`key-avatar-${host.name}`} className={'half'} name={host.name} source={host.avatar} color={COLORS[0]} />
              <span className={'type-medium fz13 type-light ellipsis'}>{host.name}</span>
            </div>
          )}
        </div>
        <div className={'flexColumn'} style={{ alignItems: 'end', gap: 8 }}>
          <div className={'flexRow'}>
            { room.a.map( (u,i) => <Avatar key={`key-avatar-${u.name}`} className={'half'} style={{marginRight: (i + 1 === room.limit) ? 0 : -3, zIndex: (100 - i)}} name={u.name} source={u.avatar} color={COLORS[i]} /> ) }
            { Array(room.limit - room.a.length).fill(null).map( (x,y) => <Avatar key={`key-avatar-empty-${y}`} className={'half'} style={{marginRight: (room.a.length + 1 + y === room.limit) ? 0 : -3, zIndex: (100 - (y + room.a.length)), background: '#0D0D0D' }} name={'empty'} source={'transparent'} color={'#383838'} /> ) }
          </div>
          <span className={'type-medium fz13 type-secondary'}>{duration}</span>
          <div className={'flexCenter'}>
            { room.limit === room.a.length
              ? <span className={'type-medium fz13'}>Party is Full</span>
              : <span className={'type-medium fz13 brand-primary button-join'} onClick={joinSession(room.id, room.tokenA)}>Join set ></span>
            }
          </div>
        </div>
      </div>
      <DividingLine />
    </>
  )
}

BlockSession.propTypes = {
  room: PropTypes.object
}

export default BlockSession;
